import {Tab} from "../../esm";

function slideNav($container) {
	if ($container.length) {
		let $linkActive = $container.find('ul > .active').first(),
			$slider = $container.find('.slide');

		if ($linkActive.length) {
			let width = $linkActive.width(),
				left = $linkActive.position().left || 0;

			$linkActive.addClass('hover');

			$slider.css('width', width);
			$slider.css('left', left);
		}

		$container.find('ul > li > button').on('mouseover', function () {
			let $self = $(this),
				$linkActive = $self.closest('li');

			if ($linkActive) {
				let width = $linkActive.width(),
					left = $linkActive.position().left || 0;

				$container.find('.hover').removeClass('hover');
				$linkActive.addClass('hover');

				$slider.css('width', width);
				$slider.css('left', left);
			}

			return false;
		});

		$container.find('ul > li > button').on('mouseout', function () {
			let $linkActive = $container.find('ul > .active').length ? $container.find('ul > .active') : $container.find('ul > li').first() || null;

			if ($linkActive) {
				let width = $linkActive.width(),
					left = $linkActive.position().left;

				$container.find('.hover').removeClass('hover');
				$linkActive.addClass('hover');

				$slider.css('width', width);
				$slider.css('left', left);
			}

			return false;
		});

		const triggerTabList = document.querySelectorAll('.nav-tabs .nav-link');
		if (triggerTabList.length) {
			triggerTabList.forEach(triggerEl => {
				const tabTrigger = new Tab(triggerEl);

				triggerEl.addEventListener('click', event => {
					event.preventDefault()
					tabTrigger.show();

					let prdTabs = triggerEl.closest('.nav-tabs'),
						prdTabsLi = prdTabs.querySelectorAll('li');

					prdTabsLi.forEach(function (elem) {
						elem.classList.remove('active');
					});

					tabTrigger._getActiveElem().closest('li').classList.add('active')
				})
			})
		}
	}
}

export default slideNav;
